import axios, { AxiosRequestConfig } from 'axios'

import { IRecommend } from '@/types/recommend'
import { IMatched } from '@/types/matched'

export const getMatcheds = async (
  createdAtStart: string,
  createdAtEnd: string,
  code: string,
  targetName: string,
  isTargetNamePerfectMatch: boolean,
  targetOcr: string,
  isTargetOcrPerfectMatch: boolean,
  categoryId = -1,
  isToBeDeleted = false,
  isApproved = false,
  suggestName: string,
): Promise<{ items: IRecommend[]; total: number }> => {
  const config: AxiosRequestConfig = {
    params: {
      createdAtStart,
      createdAtEnd,
      code,
      targetName,
      isTargetNamePerfectMatch,
      targetOcr,
      isTargetOcrPerfectMatch,
      categoryId,
      isToBeDeleted,
      isApproved,
      suggestName,
    },
  }
  try {
    const response = await axios.get<{ items: IRecommend[]; total: number }>(
      'matcheds',
      config,
    )
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.matcheds.getMatcheds')
  }
}

export const updateMatched = async (
  id: string,
  matched: IMatched,
): Promise<void> => {
  const config: AxiosRequestConfig = {
    params: {},
  }
  try {
    await axios.put<IMatched>(`matcheds/${id}`, matched, config)
  } catch (error) {
    console.error(error)
    throw new Error('error.matcheds.updateMatched')
  }
}

export const updateMatchedByName = async (
  name: string,
  matched: IMatched,
): Promise<void> => {
  const config: AxiosRequestConfig = {
    params: {
      name,
    },
  }
  try {
    await axios.put<IMatched>(`matcheds/by-name`, matched, config)
  } catch (error) {
    console.error(error)
    throw new Error('error.matcheds.updateMatchedByName')
  }
}

export const updateMatchedByIds = async (
  ids: string[],
  matched: IMatched,
): Promise<void> => {
  const config: AxiosRequestConfig = {
    params: {},
  }
  try {
    await axios.put<IMatched>(
      'matcheds/by-ids',
      {
        ids,
        matched,
      },
      config,
    )
  } catch (error) {
    console.error(error)
    throw new Error('error.matcheds.updateMatchedByIds')
  }
}

export const deleteMatched = async (id: string): Promise<void> => {
  const config: AxiosRequestConfig = {
    params: {},
  }
  try {
    await axios.delete<void>(`matcheds/${id}`, config)
  } catch (error) {
    console.error(error)
    throw new Error('error.matcheds.deleteMatched')
  }
}

export const deleteMatchedByName = async (name: string): Promise<void> => {
  const config: AxiosRequestConfig = {
    params: {
      name,
    },
  }
  try {
    await axios.delete<void>(`matcheds/by-name`, config)
  } catch (error) {
    console.error(error)
    throw new Error('error.matcheds.deleteMatchedByName')
  }
}
